import React, { useState, useCallback } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import SignupCollectionAction from './SignupCollectionAction';
import UploadImages from './UploadImages';

const Step6Collection = (props) => {
    const [isSending, setIsSending] = useState(false);
    const [canContinue, setCanContinue] = useState(false);

    const getSending = useCallback((value) => {
        setIsSending(value);
    }, []);

    const hasError = useCallback((error) => {
        setCanContinue(Boolean(!error));
    }, []);

    return (
        <>
            <div className="step-container">
                <div className="step-circle">
                    <span>5</span>
                </div>
                <UploadImages optional={false} getSending={getSending} hasError={hasError} />
            </div>
            <SignupCollectionAction
                step={5}
                optional={props.optional}
                isValid={canContinue}
                isSending={isSending}
            />
        </>
    );
};

Step6Collection.propTypes = {
    optional: PropTypes.bool
};

const mapStateToProps = (state) => ({
    optional: state.collection.optional
});

export default connect(mapStateToProps, null)(Step6Collection);
